export default objects => {
	for (let i = 0; i < objects.length; i++)
		obj.remove();
	return objects;
}
